import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  fallbackSizes: {
    md: 'sm',
    tiny: 'xs'
  },
  fallbackVariants: {
    'primary-inverse': 'secondary',
    'secondary-inverse': 'primary',
  },
  sizes: ['xs', 'sm'],
  variants: [
    'primary',
    'secondary',
    'tertiary',
    'tertiary-inverse',
  ]
} satisfies RecursivePartial<VfConfig['button']>
